import React from 'react';

import { Auth } from 'aws-amplify';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Col, Form, Row } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { hideStatusMsg, onErrorMsg, onWarningMsg } from '../../actions/FlashMessage/FlashMessages';
import { setNavigateToMsg } from '../../actions/Notifications/ScreenReaderInit';
import { setPageTitle } from '../../actions/Page/PageAction';
import {
  cleanUserToken,
  setLoggedUserDetailsSuccess,
  getUserDetailsFromSession,
  getUserToken,
  sendGADimensions,
} from '../../actions/Users/UserAction';
import { ADMINISTRATOR_USER, ASSOCIATION_USER, SUPER_USER, TRUE_STRING } from '../../actionTypes/Users/UserActionType';
import { asErrMsgKey, hasAnyError, isEmailValid, isValueValid } from '../Common/Errors/Errors';
import Inputs from '../Common/Inputs/Inputs';
import FlashMessages from '../Common/Messages/FlashMessages';
import Footer from '../Footer/Footer';
import Header from '../Headers/Header';
import { Fragment } from 'react';
import FormButtons from '../Common/FormParts/FormButtons';
import { G_MSG_CHANNEL } from '../../routes/PRoute';
import Api from '../../Api';
import { compareIgnoreCase } from '../../utils/helpers';

import withNavigate from '../HOC/navigate';
class SignIn extends React.Component {
  state = {
    username: '',
    password: '',
    user: {},
    load: false,
    validation: true,
    formInputsValidation: {},
  };

  constructor(props) {
    super(props);
  }

  componentWillUnmount() {
    this.props.setPageTitle();
  }

  componentDidMount() {
    this.props.setPageTitle('Login');
    this.props.cleanUserToken();
    Auth.signOut();
    if (this.props.statusMessage.pageLocation && this.props.statusMessage.pageLocation !== '/login') {
      hideStatusMsg();
    }
    this.showWarningMessage();
    this.props.setNavigateToMsg('Sign in');
  }

  handleInputChange = (inputFields, value) => {
    this.setState({
      [inputFields.name]: value,
    });
  };

  showWarningMessage = () => {
    const paramsString = this.props.location?.search;
    const params = new URLSearchParams(paramsString);
    const status = params.get('status');
    if (status === 'timeout') {
      this.props.onWarningMsg(
        'Your session has timed out due to inactivity. Please log back in to continue working.',
        '/login',
      );
      // this.props.history.push('/login');
      this.props.navigate('/login');
    } else if (status === 'logout-account') {
      this.props.onWarningMsg('You have been logged out due to another active session in the browser.', '/login');
      //this.props.history.push('/login');
      this.props.navigate('/login');
    }
  };

  submitLoginForm = async (event) => {
    event.preventDefault();

    const { username, password } = this.state;

    const formInputsValidation = {
      username: asErrMsgKey(isEmailValid(username)),
      password: asErrMsgKey(isValueValid(password)),
    };

    this.setState({ formInputsValidation });
    const hasErrors = hasAnyError(formInputsValidation);
    // prevent further auth calls unless another is completed
    if (this.state.load || hasErrors) {
      return;
    }

    this.setState({ load: true });
    this.props.hideStatusMsg();
    document.getElementById('button-signin-id').focus();
    requestAnimationFrame(() => {
      this.signInUser();
    });
  };

  signInUser = async () => {
    const username = this.state.username.toLowerCase().trim();
    G_MSG_CHANNEL.postMessage({ action: 'logout', userEmail: username });

    try {
      await Auth.signIn(username, this.state.password);
      Api.instance.reset();
      this.props.getUserToken(); // ?
      const userDetails = await getUserDetailsFromSession();
      this.props.setLoggedUserDetailsSuccess(userDetails);

      sendGADimensions(userDetails.userPrincipalId);
      if (userDetails.userRole === SUPER_USER) {
        this.props.navigate('/users');
      } else if (
        (userDetails.userRole === ADMINISTRATOR_USER || userDetails.userRole === ASSOCIATION_USER) &&
        compareIgnoreCase(userDetails.userManagementAccess, TRUE_STRING)
      ) {
        this.props.navigate('/users');
      } else {
        this.props.navigate('/');
      }
      // this.props.history.push(userDetails.userRole === SUPER_USER ? '/users' : '/');
      // this.props.navigate(userDetails.userRole === SUPER_USER ? '/users' : '/');
    } catch (err) {
      const errMsg = err.message ? err.message : err;
      if (errMsg === 'Password attempts exceeded') {
        this.props.hideStatusMsg();
        //this.props.history.push('/accountLocked');
        this.props.navigate('/accountLocked');
      } else {
        this.props.onErrorMsg('Incorrect username or password.', '/login');
      }
      this.setState({ load: false });
    }
  };

  render() {
    let { statusMessage, hideStatusMsg } = this.props;
    let { msgShow, msgType, msg } = statusMessage;
    return (
      <Fragment>
        <Header plainLogo />
        <main role="main" className="main-page" aria-describedby="app_page_title">
          <FlashMessages
            close={hideStatusMsg}
            type={msgType}
            open={msgShow}
            msg={msg}
            scope="SignIn"
            classNames={'fl-sing-in'}
          />
          <div className="mobile_margin login fontSm-15">
            <h1 id="app_page_title" className="heading-h1-50">
              Welcome
            </h1>
            <Form
              role="form"
              aria-labelledby="app_page_title innerFormTitle"
              className="login-form pSm-30"
              onSubmit={this.submitLoginForm}>
              <h2 id={'innerFormTitle'} className="heading-h6-15">
                Sign in to access your reports:
              </h2>
              <Inputs
                autoComplete={'username'}
                onInputChange={this.handleInputChange}
                errorMessages={this.state.formInputsValidation.username}
                labelSize={3}
                required
                title="Email"
                name="username"
                placeholder="username"
                id={'username'}
                value={this.state.username}
              />
              <Inputs
                autoComplete={'current-password'}
                onInputChange={this.handleInputChange}
                errorMessages={this.state.formInputsValidation.password}
                labelSize={3}
                required="required"
                title="Password"
                name="password"
                type="password"
                placeholder="Password"
                id={'password'}
                value={this.state.password}
              />
              <FormButtons
                isBusy={this.state.load}
                submitLabel="Sign In"
                wrapperClassNames={[]}
                extraButtonProps={{
                  stretch: true,
                  id: 'button-signin-id',
                  type: this.state.load ? 'button' : 'submit',
                  classNames: ['mBottom-20'],
                }}
              />
              <Row>
                <Col xs={6} className="anchorParent">
                  <Link to="/forgotPassword" label="Cancel" className="anchor">
                    Forgot your password
                  </Link>
                </Col>
                <Col xs={6} className="text-right anchorParent">
                  <a
                    className="anchor"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://help.liaisonedu.com/Analytics">
                    Need Help?
                  </a>
                </Col>
              </Row>
            </Form>
          </div>
        </main>
        <Footer />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    statusMessage: state.FlashMessages.statusMsg,
    casDetails: state.AppSession.activeCasDetails,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      hideStatusMsg,
      onErrorMsg,
      onWarningMsg,
      getUserToken,
      setLoggedUserDetailsSuccess,
      cleanUserToken,
      setNavigateToMsg,
      setPageTitle,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(withNavigate(SignIn));
